import { API } from "aws-amplify";
import * as mutations from "../../graphql/mutations";
import { ICreatePageVisitLogParams } from "./types";
import { CreatePageVisitLogMutation } from "../../API";

class PageVisitLogService {
  /*
    Task: Create a new PageVisitLog using graphql
  */
  async createPageVisitLog(pageVisitLog: ICreatePageVisitLogParams) {
    try {
      // send grapql api call
      const temp: any = (await API.graphql({
        query: mutations.createPageVisitLog,
        variables: { input: pageVisitLog },
        authMode: "AMAZON_COGNITO_USER_POOLS",
      })) as { data: CreatePageVisitLogMutation; errors: any[] };

      // send back newly created PageVisitLog details
      return temp.data.createPageVisitLog;
    } catch (error) {
      return null;
    }
  }
}

export { PageVisitLogService };
